export default {
  adapters: {
    breadcrumbs: {
      editorial: {
        home: 'Strona główna'
      },
      ugr: {
        home: 'Strona główna'
      },
      recipes: {
        home: 'Przepisy'
      }
    },
    cards: {
      userCollection: {
        savedItemDescription_one: 'element',
        savedItemDescription_few: 'elementy',
        savedItemDescription_many: 'elementów',
        savedItemDescription_0: 'element',
        savedItemDescription_1: 'elementy',
        savedItemDescription_2: 'elementów'
      },
      userRecipe: {
        statusTextDraft: 'Szkic przepisu',
        statusApproved: 'Przepis użytkownika',
        statusPending: 'Oczekuje na zatwierdzenie',
        statusRejected: 'Przepis odrzucony'
      }
    },
    iconAdapter: {
      formatTimeHours_one: '{{hours}} godz.',
      formatTimeHours_few: '{{hours}} godz.',
      formatTimeHours_many: '{{hours}} godz.',
      formatTimeHours_0: '{{hours}} godz.',
      formatTimeHours_1: '{{hours}} godz.',
      formatTimeHours_2: '{{hours}} godz.',
      formatTimeMins_one: '{{minutes}} min',
      formatTimeMins_few: '{{minutes}} min',
      formatTimeMins_many: '{{minutes}} min',
      formatTimeMins_0: '{{minutes}} min',
      formatTimeMins_1: '{{minutes}} min',
      formatTimeMins_2: '{{minutes}} min'
    },
    pageSchema: {
      editorial: {
        recipe: {
          calories: '{{calories}} kalorii',
          carbContent: '{{carbs}} gram węglowodanów',
          fatContent: '{{fat}} gram tłuszczu',
          fibreContent: '{{fibre}} gram błonnika',
          proteinContent: '{{protein}} gram białka',
          satFatContent: '{{saturates}} gram tłuszczu nasyconego',
          sodiumContent: '{{sodium}} miligram sodu',
          sugarContent: '{{sugars}} gram cukru'
        }
      },
      ugr: {
        servesDefault: 'Dostarcza'
      }
    },
    post: {
      ugr: {
        messageMember: 'Przepis użytkownika',
        messageOther: 'Przepis {{status}}',
        statuses: {
          draft: 'draft',
          approved: 'zatwierdzony',
          rejected: 'usunięty',
          pending: 'oczekujący',
          published: 'opublikowany'
        }
      }
    },
    posts: {
      editorial: {
        liveBlog: {
          hour_one: 'godzinę temu',
          hour_few: 'godziny temu',
          hour_many: 'godzin temu',
          hour_0: 'godzinę temu',
          hour_1: 'godziny temu',
          hour_2: 'godzin temu',
          lessThanHour_one: 'minutę temu',
          lessThanHour_few: 'minuty temu',
          lessThanHour_many: 'minut temu',
          lessThanHour_0: 'minutę temu',
          lessThanHour_1: 'minuty temu',
          lessThanHour_2: 'minut temu',
          lessThanMinute: 'mniej niż minutę temu',
          updatedMessageLive: 'Uaktualniane na żywo',
          updatedMessageNotLive: 'Uaktualnione'
        }
      },
      postAdapter: {
        callout: 'To jest {{status}} {{entity}}',
        recommendedTitle: 'Więcej podobnych',
        statuses: {
          draft: 'draft',
          approved: 'zatwierdzony',
          rejected: 'odrzucony',
          pending: 'nierozstrzygnięty',
          published: 'opublikowany'
        },
        entities: {
          glossary: 'słowniczek',
          howTo: 'w jaki sposób',
          editorialList: 'lista redakcyjna',
          plant: 'roślina',
          post: 'post',
          recipe: 'przepis',
          review: 'recenzja',
          'broadcast-show': 'program',
          venue: 'miejsce',
          page: 'strona',
          'user-collection': 'kolekcja użytkownika',
          blog: 'blog'
        }
      },
      recipeAdapter: {
        getPublicationMessage: 'Przepis od',
        nutritionHighInPrefix: 'bogaty w',
        nutritionLabel: 'Wartości odżywcze',
        nutritionLowInPrefix: 'ubogi w',
        recommendedAltTitle: 'Inne propozycje',
        servingsLabel: 'Dostarcza'
      },
      userRecipeAdapter: {
        categoryDisplay: 'Przepisy'
      }
    }
  }
};